export const radarConstants = {
    SET_RADARS: 'RADAR_SET_RADAR',
    SET_SELECTED_RADAR_DATE: 'RADAR_SET_SELECTED_RADAR_DATE',
};
